import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'

export default {
  ...cloneDeep(baseDefaults),
  variant: 'thin',
  dividerColor: 'var(--color-primary)',
  textColor: 'black',
  maxWidth: { value: 100, unit: '%'},
  verticalPadding: { value: 16, unit: 'px'},
  withText: false,
  text: 'divider text'
}
